import { ErrorSource } from "@/constants/apiFields";
import { useErrorManager } from "./ErrorManagerContextProvider";
import { useEffect } from "react";

interface UseRegisterErrorProps {
    id: string;
    source: ErrorSource;
    error?: {
        message: string;
        status?: number;
    };
    componentId: string;
    retryFn: () => void;
    trigger: boolean;
}

export const useRegisterError = ({ id, source, error, componentId, retryFn, trigger }: UseRegisterErrorProps) => {
    const { registerError } = useErrorManager();

    useEffect(() => {
        if (trigger) {
            registerError({ id, source, error, componentId, retryFn });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger])
}